import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    mediaBasketRoot: {
      display: "none"
    },
    header: {
      display: "flex",
      alignItems: "center",
      height: 45,
      textTransform: "capitalize",
      fontSize: 12,
      color: primary.dark
    },
    optionalText: {
      textTransform: "lowercase",
      color: primary.light
    },
    mediaContainer: {
      display: "flex",
      flexWrap: "wrap",
      marginTop: "-8px",
      "&:last-child": {
        marginRight: 0
      }
    },
    addMediaButton: {
      width: 87,
      height: 54,
      margin: "8px 8px 0 0",
      borderRadius: 3,
      border: `1px dashed ${primary.light}`
    }
  };
});
